import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: `landing.teacher.faq.title`,
    defaultMessage: `Les questions fréquentes`,
  },
});
